import api from './api'

export default {
  async getViolationList({ commit, state }, params) {
    let res = {}
    try {
      res = await api.getViolationList(params)
    } catch (error) {
      throw new Error(error.errmsg)
    }
    return res.data
  },
  async getNotificationControl({ commit, state }, params) {
    let res = {}
    try {
      res = await api.getNotificationControl(params)
    } catch (error) {
      throw new Error(error.errmsg)
    }
    return res.data
  },
  async getConfigList({ commit, state }, params) {
    let res = {}
    try {
      res = await api.getConfigList(params)
    } catch (error) {
      throw new Error(error.errmsg)
    }
    return res.data
  },
  async getViolationDetail({ commit, state }, params) {
    let res = {}
    try {
      res = await api.getViolationDetail(params)
    } catch (error) {
      throw new Error(error.errmsg)
    }
    return res.data
  },
  async addFeedInfo({ commit, state }, params) {
    let res = {}
    try {
      res = await api.addFeedInfo(params)
    } catch (error) {
      throw new Error(error.errmsg)
    }
    return res.data
  },
  async setAppeal({ commit, state }, params) {
    let res = {}
    try {
      res = await api.setAppeal(params)
    } catch (error) {
      throw new Error(error.errmsg)
    }
    return res.data
  },
  async setResolve({ commit, state }, params) {
    let res = {}
    try {
      res = await api.setResolve(params)
    } catch (error) {
      throw new Error(error.errmsg)
    }
    return res.data
  },
}
